import { useEffect, useState } from "react";

const VERBS = [
  "Thinking",
  "Churning",
  "Spelunking",
  "Pondering",
  "Wrangling",
  "Cogitating",
  "Brewing",
  "Mulling",
  "Computing",
  "Rummaging",
  "Untangling",
  "Distilling",
];

export function StreamingIndicator() {
  const [i, setI] = useState(() => Math.floor(Math.random() * VERBS.length));
  useEffect(() => {
    const tick = setInterval(() => setI((n) => (n + 1) % VERBS.length), 2500);
    return () => clearInterval(tick);
  }, []);
  return (
    <div className="streaming-indicator" aria-live="polite">
      <span className="spinner spinner--sm" aria-hidden="true" />
      <span className="streaming-verb">{VERBS[i]}…</span>
    </div>
  );
}
